import { DISCOUNT_TYPES } from '../order-fields';

export function applyDiscount(discount, round = false) {
  return (item) => {
    if (item.priceOptions) {
      item.priceOptions.forEach(opt => applyDiscountToPriceOption(opt, discount, round));
    } else {
      applyDiscountToPriceOption(item, discount, round);
    }
    return item;
  };
}

function applyDiscountToPriceOption(item, discount, round) {
  item.oldPrice = item.price;
  item.price = substractPercentFromNum(item.oldPrice, discount, round);
}

export function substractPercentFromNum(num, percent, round) {
  if (round) {
    return Math.round((num * (100 - percent)) / 100 - 0.1);
  } else {
    return (num * (100 - percent) / 100);
  }
}

export function applyDiscountToWholeMenu(menu, percent = 10, round = false) {
  const itemDiscounter = applyDiscount(percent, round);
  menu.categories.forEach(category => {
    category.items.forEach(itemDiscounter)
  });
  return menu;
}

function mapRuleTypesToLabels(rule = {}, item = {}) {
  const { type = '', percent } = rule;
  const { name = '', category = '' } = item;
  const categoryPart = category ? `${category} ` : '';
  const namePart = name ? `${name} ` : '';
  const ruleLabelsDisct = {
    [DISCOUNT_TYPES.SAME_CATEGORY]: `Drugi w kategorii ${categoryPart}o ${percent}% taniej`,
    [DISCOUNT_TYPES.SAME_PRODUCT]: `Drugi ${namePart}o ${percent}% taniej`,
  };
  return ruleLabelsDisct[type] || null;
};

export function getDiscountTypeLabel(cartItem, restaurantDetails) {
  const { discountRules = [] } = restaurantDetails;
  const activeRule = discountRules.find(rule => {
    if (rule.type === DISCOUNT_TYPES.SAME_CATEGORY && rule.categoryName === cartItem.category) {
      return rule;
    }
    if (rule.type === DISCOUNT_TYPES.SAME_PRODUCT && rule.productName === cartItem.name) {
      return rule;
    }
    return null;
  });
  return activeRule ? mapRuleTypesToLabels(activeRule, cartItem) : null;
}
